import axios from 'axios';
import config from './Config';

axios.defaults.baseURL = config.url.API_URL;

const instance = {
  settingsURL: config.url.SETTING_URL
};

export default instance;
